import React from 'react';
import { Empty } from 'antd';
import { useDurablePipeline } from '../../../../core/modules/pipelines/hooks';
import { DurableDetailSkeleton } from '../skeletons';
import { DurableApp } from '../../../../core/modules/pipelines/pipelines.model';
import HeroHeader from '../HeroHeader';
import HorizontalStages from '../HorizontalStages';
import ActivityTabs from './ActivityTabs';
import { RecentRunsHeader, Section, SubHeading } from './detail-shared';

interface IDurableDetailProps {
  app: DurableApp;
  orchestrator: string;
  title: string;
  schedule: string;
  description?: string | null;
  onClose?: () => void;
}

const DurableDetail: React.FC<IDurableDetailProps> = ({
  app, orchestrator, title, schedule, description, onClose
}) => {
  const { data, isLoading, isFetching, isError } = useDurablePipeline(app, orchestrator);

  if (isLoading) {
    return <DurableDetailSkeleton />;
  }

  if (isError || !data) {
    return <Empty description='Failed to load pipeline status' />;
  }

  const detail = data.data;
  const { current } = detail;

  return (
    <>
      <HeroHeader
        title={title}
        schedule={schedule}
        current={current}
        cacheStatus={data.cache}
        fetchedAt={data.fetched_at}
        description={description}
        onClose={onClose}
      />

      <Section>
        <SubHeading>Stages</SubHeading>
        {current ? (
          <HorizontalStages stages={current.stages} pipelineStartedAt={current.startedAt} />
        ) : (
          <Empty description='No recent runs' />
        )}
      </Section>

      <Section>
        <RecentRunsHeader isFetching={isFetching} />
        <ActivityTabs
          runs={detail.runs}
          current={current}
          emptyDescription='No recent activity runs'
        />
      </Section>
    </>
  );
};

export default DurableDetail;
